<template>
  <v-container fluid>
    <ContentHeader
      header-title="New Vendor Onboarding Management"
    ></ContentHeader>
    <v-row>
      <v-col md="7" class="pb-6">
        <PtSheet title="NVO Aging Report" class="fill-height">
          <v-card-text>
            <NvoAgingReport :aging-data="onboardingStats.agingStats" />
          </v-card-text>
        </PtSheet>
      </v-col>
      <v-col md="5" sm="12">
        <PtSheet
          title="Average Days to Onboard"
          tooltip="Average Days to Onboard represents the average number of days it took for onboarding workflows to be
          completed. It does not include incomplete onboarding workflows."
        >
          <v-card-text class="colorNeutralsNavy400--text">
            <div class="display-3 text-center">
              {{ onboardingStats.averageDaysToCompleteOnboarding }} Days
            </div>
            <v-divider class="my-4" />
            <div>
              The ideal onboarding should take between 3 to 7 days for optimum
              engagement.
            </div>
          </v-card-text>
        </PtSheet>
        <v-row>
          <v-col cols="6">
            <PtSheet
              title="Enrolled"
              class="text-center"
              tooltip="Percentage of vendors who were invited to enroll via New Vendor Onboarding who have completed
              their enrollment."
            >
              <v-card-text>
                <v-progress-circular
                  v-if="this.statsLoading"
                  indeterminate
                  color="primary"
                  :size="180"
                  :width="22"
                ></v-progress-circular>
                <ProgressCircle v-else :value="enrolledPercent" />
              </v-card-text>
            </PtSheet>
          </v-col>
          <v-col cols="6">
            <PtSheet
              title="Completed"
              class="text-center"
              tooltip="Percentage of New Vendor Onboarding workflows that have been completed."
            >
              <v-card-text>
                <v-progress-circular
                  v-if="this.statsLoading"
                  indeterminate
                  color="primary"
                  :size="180"
                  :width="22"
                ></v-progress-circular>
                <ProgressCircle v-else :value="completedPercent" />
              </v-card-text>
            </PtSheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <PtSheet title="Vendor Onboarding Management">
      <v-card-text>
        <OnboardingTable />
      </v-card-text>
    </PtSheet>
  </v-container>
</template>

<script>
import hasNotifications from "@/mixins/has-notifications";
import ContentHeader from "@/views/ContentHeader";
import NvoAgingReport from "@/views/client/NvoAgingReport";
import OnboardingTable from "@/views/client/OnboardingTable";
import ProgressCircle from "@/components/providertrust/ProgressCircle.vue";
import PtSheet from "@/components/PtSheet.vue";
import { get } from "@/services/request";
import { onboardingStatsAPI } from "@/services/api";

export default {
  mixins: [hasNotifications],
  name: "OnboardingPage",
  components: {
    PtSheet,
    ProgressCircle,
    ContentHeader,
    NvoAgingReport,
    OnboardingTable
  },
  data() {
    return {
      statsLoading: true,
      onboardingStats: {}
    };
  },
  computed: {
    enrolledPercent() {
      return !this.onboardingStats || this.onboardingStats.totalOnboarding === 0
        ? 0
        : Math.round(
            (this.onboardingStats.enrolled /
              this.onboardingStats.totalOnboarding) *
              100
          );
    },
    completedPercent() {
      return !this.onboardingStats || this.onboardingStats.totalOnboarding === 0
        ? 0
        : Math.round(
            (this.onboardingStats.complete /
              this.onboardingStats.totalOnboarding) *
              100
          );
    }
  },
  watch: {},
  created() {
    this.loadStats();
  },
  methods: {
    loadStats() {
      this.statsLoading = true;
      get(onboardingStatsAPI).then(response => {
        if (response && response.data) {
          this.onboardingStats = response.data;
        }
        this.statsLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
